import * as THREE from 'three';
import p5 from "p5";
import { Params } from '../../data/Params';
import { QTree } from './QTree';
import { DrawerBase } from './DrawerBase';
import { basename } from 'path';
import { QTreeRect } from '../drawer/QTreeRect';
import { KTree } from './KTree';

export class KTreeDrawer extends DrawerBase{

    p5:p5;
    qTree:KTree;
    

    constructor(tgt:p5){
        super();
        this.p5 = tgt;
        this.qTree = new KTree();
        this.qTree.update(6);
        this.rects = this.qTree.rects;
    }

    show(): void {
        super.show();
        this.count=0;
    }

    hide(): void {
        super.hide();
        this.qTree.hide();
    }

    update(){
        
        let rect = this.rects[this.count%this.rects.length];
        if(this.count<this.rects.length) rect.show();

        for(let i=0;i<this.rects.length;i++){
            this.rects[i].update(this.p5);
        }
        this.count++;

    }

}